import { render } from "./IconRedo.vue?vue&type=template&id=4e98fbec"
import script from "./IconRedo.vue?vue&type=script&lang=js"
export * from "./IconRedo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__